export const ERROR_MESSAGE = 'Oops! Something Went Wrong. Please Try Again Later.'
export const PROCESSING_MESSAGE = 'Please Wait While We Are Processing'
export const FORGOT_USERNAME = 'forgotUsername'
export const FORGOT_PASSWORD = 'forgotPassword'